module.exports = __webpack_public_path__ + "static/media/banner-2.75eaf347.png";